/**
 * Search keywords are typed into a plain text box, one per line or separated by
 * commas, and stored as a list. These two functions convert between the two
 * forms.
 *
 * Keywords exist to bridge wording the content itself never uses — a post that
 * says "basin" is unreachable by a search for "resource play" unless someone
 * says the two belong together.
 */

/** Turns what the admin typed into a clean list, dropping blanks and duplicates. */
export function parseKeywords(text: string): string[] {
  const seen = new Set<string>();
  return text
    .split(/[\n,]/)
    .map((keyword) => keyword.trim())
    .filter((keyword) => {
      if (keyword === "") return false;
      const normalised = keyword.toLowerCase();
      if (seen.has(normalised)) return false;
      seen.add(normalised);
      return true;
    });
}

/** Renders a stored list back into the text box, one keyword per line. */
export function formatKeywords(keywords: Maybe<string[]>): string {
  return (keywords ?? []).join("\n");
}
